var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAblehnen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.338,
    height: 53.814,
    viewBox: "0 0 49.338 53.814",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1",
    "data-name": "Ebene 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "abmeldung"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3357",
    "data-name": "Pfad 3357",
    d: "M217.548,73.543H204.58a3.992,3.992,0,0,1-.576-.017.817.817,0,0,1-.741-.766.794.794,0,0,1,.537-.91,2.164,2.164,0,0,1,.72-.091q13.076-.005,26.151,0a2.107,2.107,0,0,1,.67.075.879.879,0,0,1-.194,1.7,4.492,4.492,0,0,1-.577.014Z",
    transform: "translate(-187.991 -66.369)",
    fill: "#00467d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3358",
    "data-name": "Pfad 3358",
    d: "M214.4,145.251h-9.872c-.9,0-1.329-.3-1.32-.9s.441-.89,1.344-.89h19.693c.938,0,1.386.3,1.376.914s-.437.882-1.347.882Z",
    transform: "translate(-187.955 -132.692)",
    fill: "#00467d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3359",
    "data-name": "Pfad 3359",
    d: "M211.358,215.162h6.774a3.213,3.213,0,0,1,.576.027.875.875,0,0,1,.133,1.685,2.156,2.156,0,0,1-.672.075q-6.8.005-13.6,0a2.445,2.445,0,0,1-.622-.059.876.876,0,0,1,.115-1.711,4.1,4.1,0,0,1,.576-.02Z",
    transform: "translate(-188.045 -199.006)",
    fill: "#00467d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3360",
    "data-name": "Pfad 3360",
    d: "M587.225,246.416v5.879a3.415,3.415,0,0,1-.027.576.826.826,0,0,1-.86.751.844.844,0,0,1-.878-.736,2.655,2.655,0,0,1-.03-.47V240.3c.033-.636.369-1,.914-.99a.877.877,0,0,1,.883.871.827.827,0,0,1-.005.1c.019.525.006,1.051.006,1.576Q587.226,244.129,587.225,246.416Z",
    transform: "translate(-541.487 -221.345)",
    fill: "#00467d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3361",
    "data-name": "Pfad 3361",
    d: "M585.444,455.8c0-.315-.023-.631,0-.943a.887.887,0,0,1,.891-.859.86.86,0,0,1,.864.826,17.355,17.355,0,0,1,0,1.937.826.826,0,0,1-.842.815h-.015a.853.853,0,0,1-.9-.8v-.025C585.422,456.43,585.445,456.114,585.444,455.8Z",
    transform: "translate(-541.492 -419.922)",
    fill: "#00467d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3362",
    "data-name": "Pfad 3362",
    d: "M133.178,73.476c-.3,0-.6.014-.892,0a.885.885,0,0,1-.868-.821.86.86,0,0,1,.751-.929,14.554,14.554,0,0,1,2.094,0,.829.829,0,0,1,.724.92v.016a.85.85,0,0,1-.863.812C133.809,73.491,133.5,73.476,133.178,73.476Z",
    transform: "translate(-121.551 -66.306)",
    fill: "#00467d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3363",
    "data-name": "Pfad 3363",
    d: "M133.306,215.27c.332,0,.667-.026,1,.006a.791.791,0,0,1,.766.786.761.761,0,0,1-.577.907.8.8,0,0,1-.083.014,12.5,12.5,0,0,1-2.242-.005c-.45-.041-.66-.436-.656-.883a.844.844,0,0,1,.8-.826c.33-.028.664-.005,1-.005Z",
    transform: "translate(-121.638 -199.098)",
    fill: "#00467d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3364",
    "data-name": "Pfad 3364",
    d: "M133.266,145.2c-.331,0-.666.025-1-.006a.85.85,0,0,1-.8-.873.808.808,0,0,1,.751-.862h0a13.893,13.893,0,0,1,2.091.007.781.781,0,0,1,.724.835.154.154,0,0,1-.005.049.844.844,0,0,1-.769.847,1.1,1.1,0,0,1-.157.016h-.838Z",
    transform: "translate(-121.596 -132.658)",
    fill: "#00467d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3365",
    "data-name": "Pfad 3365",
    d: "M28.458,357.118c-2.672-2.6-5.374-5.172-8.067-7.749a3.037,3.037,0,0,0-.554-.325c.295-.25.42-.345.533-.45l8-7.673a3.683,3.683,0,0,0,1.223-2.587,3.583,3.583,0,0,0-6.1-2.671q-3.308,3.152-6.594,6.331c-.69.662-1.383,1.322-2.09,2-.174-.161-.316-.288-.45-.42q-4.041-3.873-8.069-7.749a3.8,3.8,0,0,0-2.447-1.181,3.588,3.588,0,0,0-3.516,2.1,3.528,3.528,0,0,0,.751,4.018c1.612,1.583,3.252,3.134,4.879,4.7l3.706,3.562c-.2.164-.39.295-.552.45q-3.978,3.814-7.956,7.637a3.589,3.589,0,0,0,1.624,6.117,1.817,1.817,0,0,1,.237.1H4.17a5.7,5.7,0,0,0,2.608-1.666c2.523-2.454,5.072-4.879,7.612-7.315.125-.12.255-.235.418-.383,1.071,1.027,2.129,2.04,3.185,3.054,1.819,1.746,3.608,3.528,5.472,5.219A9.755,9.755,0,0,0,25.4,363.32h1.366a10.051,10.051,0,0,0,1.175-.546,3.559,3.559,0,0,0,.519-5.656Zm-1.164,3.843a1.814,1.814,0,0,1-2.566.031l-.075-.075c-1.827-1.737-3.641-3.488-5.459-5.234q-1.762-1.691-3.523-3.384c-.682-.655-1.066-.664-1.738-.02q-4.453,4.269-8.9,8.545a1.934,1.934,0,0,1-1.743.646,1.679,1.679,0,0,1-1.405-1.192,1.726,1.726,0,0,1,.489-1.873q2.384-2.295,4.772-4.585l4.167-4c.663-.64.661-1.075-.008-1.718q-4.372-4.2-8.753-8.4a1.919,1.919,0,0,1-.721-1.809,1.779,1.779,0,0,1,1.777-1.481l.081-.134a7.284,7.284,0,0,1,1.291.8c3,2.841,5.973,5.71,8.955,8.568.676.65,1.051.646,1.738-.007q4.47-4.295,8.937-8.591a1.852,1.852,0,0,1,1.753-.6,1.78,1.78,0,0,1,.919,3c-.54.573-1.126,1.1-1.695,1.647q-3.637,3.491-7.276,6.981c-.717.689-.713,1.094.015,1.792l8.638,8.288c.063.06.127.122.188.182a1.785,1.785,0,0,1,.248,2.513c-.034.04-.068.08-.105.117Z",
    transform: "translate(0.003 -309.506)",
    fill: "#00c713"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3366",
    "data-name": "Pfad 3366",
    d: "M104.5,4.743A4.5,4.5,0,0,0,99.743.007h-35.3a4.493,4.493,0,0,0-4.784,4.757V21.152a3.177,3.177,0,0,0,.019.525.891.891,0,0,0,1.757-.026,4.345,4.345,0,0,0,.014-.576V4.846A2.741,2.741,0,0,1,64.5,1.8H99.646a2.745,2.745,0,0,1,3.062,3.039V39.459h-.624c-1.769,0-3.538-.007-5.307.005a6.339,6.339,0,0,0-1.3.11A4.464,4.464,0,0,0,91.937,44c-.019,2.048,0,4.1,0,6.223h-.586c-.98,0-1.959-.011-2.939.005a.88.88,0,0,0-.883,1.211.929.929,0,0,0,.969.576c1.351,0,2.7-.015,4.045.006a1.5,1.5,0,0,0,1.159-.492q5.153-5.172,10.325-10.325a1.532,1.532,0,0,0,.482-1.165Q104.5,22.392,104.5,4.743ZM93.729,48.718c0-1.57-.026-3.2.008-4.823a2.538,2.538,0,0,1,2.237-2.578c1.759-.089,3.528-.023,5.2-.023Z",
    transform: "translate(-55.171 0.003)",
    fill: "#00467d"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAblehnen);
export default __webpack_public_path__ + "static/media/ablehnen.1b13a5770579acba8efb63653389fe23.svg";
export { ForwardRef as ReactComponent };